import { DashboardState } from "../interfaces/features.interface";


export const initialState: DashboardState = {
  panelistPoints: null,
  loading: false,
  error: null,
  message: null,
};